import { DEFAULT_ZOOM } from './constants';

export interface LatLng {
  lat: number;
  lng: number;
}

// Close enough to see a single Acción's surroundings.
const MAX_ZOOM = 9;
// At zoom z the map spans 360° over 256·2^z px; ~800 px of a ~1000 px map leaves a margin around the points.
// A single point (zero span) lands on MAX_ZOOM.
const FRAME_PX = 800;

/** Center and zoom that fit `points` in the map, between the South America view and MAX_ZOOM. */
export const frame = (points: LatLng[]): { center: LatLng; zoom: number } | undefined => {
  if (points.length === 0) {
    return undefined;
  }
  const lats = points.map(point => point.lat);
  const lngs = points.map(point => point.lng);
  const [minLat, maxLat, minLng, maxLng] = [Math.min(...lats), Math.max(...lats), Math.min(...lngs), Math.max(...lngs)];
  const span = Math.max(maxLat - minLat, maxLng - minLng);
  return {
    center: { lat: (minLat + maxLat) / 2, lng: (minLng + maxLng) / 2 },
    zoom: Math.min(MAX_ZOOM, Math.max(DEFAULT_ZOOM, Math.log2(FRAME_PX / span)))
  };
};
